import { PureComponent } from "react";
import SideBySideTextAndAsset from "segments/desktop/core-components/side-by-side-text-and-asset/side-by-side-text-and-asset";
import { MD } from "constants/sizes";
import { AUTO } from "constants/cloudinary-asset-qualities";

export default class SideBySideTextAndAssetComponent extends PureComponent {
  render() {
    return (
      <div className="side-by-side-text-and-asset-component">
        <SideBySideTextAndAsset {...this.props} />
      </div>
    );
  }
}

SideBySideTextAndAssetComponent.defaultProps = {
  ...SideBySideTextAndAsset.defaultProps,
  paddingTop: "64px",
  paddingBottom: "64px",
  titleSize: MD,
  textSize: MD,
  assetQuality: AUTO,
  nestedBoardItems: {
    //props that are relevant only if the live board experience is added
    addLiveBoardTextAndAsset: false,
    boardBannerText: "Sign up for free to gain full access to all features",
    embeddedBoardTitle: "Project plan",
    addSecondLiveBoardSignUpButton: false
  }
};
